const STORAGE_KEY = 'hraAnswerPreviewLanguage';

export function getStoredHraPreviewLanguage(fallback = 'en') {
    try {
        return window.localStorage.getItem(STORAGE_KEY) || fallback;
    } catch {
        return fallback;
    }
}

export function setStoredHraPreviewLanguage(language) {
    try {
        if (language) {
            window.localStorage.setItem(STORAGE_KEY, language);
        }
    } catch {
        // ignore quota / private mode
    }
}

export function resolveHraPreviewLanguage(
    availableLanguages = ['en'],
    fallback = 'en'
) {
    const stored = getStoredHraPreviewLanguage(fallback);
    if (availableLanguages.includes(stored)) {
        return stored;
    }
    if (availableLanguages.includes(fallback)) {
        return fallback;
    }
    return availableLanguages[0] || 'en';
}
